import { defineStore } from 'pinia'
import { utmCpntTypes } from '@/utils/obcfg'
import obfn from '@/utils/obfn'

const trackingURLObj_cpnts = utmCpntTypes.reduce((obj, key) => {
  // if (!key.startsWith('cc-') && !key.startsWith('cn-')) {
  //   obj[key] = ''
  //   obj[`${key}_`] = ''
  // }
  obj[key] = ''
  obj[`${key}_`] = ''
  return obj
}, {})
const trackingURLObj_params = {
  is_cover: 'False',
  is_public: 'False',
  is_priority: 'False',
}

export const useUTMStore = defineStore('utm', {
  state: () => ({
    record: [1, 3, 4, 5],
    tkURLObj: { ...trackingURLObj_cpnts, ...trackingURLObj_params },
    curStepType: 'lp',
    curCpntType: 'lp',
    isVisible: {
      tmp: false,
    },
    recordTmp: {},
    recordCount: 0,
  }),

  getters: {
    tkURL_cnValid: (state) => {
      return obfn.checkConsistency(['cn-cs', 'cn-cp', 'cn-pn', 'cn-at'], state.tkURLObj)
    },
    tkURL_ccValid: (state) => {
      return obfn.checkConsistency(['cc-at', 'cc-cr', 'cc-af', 'cc-ag'], state.tkURLObj)
    },
  },

  actions: {
    recordSet() {
      this.record = [3, 5, 4]
    },
    tkURLObjSet(key, val) {
      this.tkURLObj[key] = val
      const obj = this.tkURLObj
      const count = ['lp', 'cs', 'cm', 'ct', 'cn', 'cc'].reduce((acc, key) => {
        const lengthSum =
          (obj[key] == '' || obj[key] == '[]' ? 0 : obj[key].split(',').length) +
          (obj[`${key}_`] == '' || obj[`${key}_`] == '[]' ? 0 : obj[`${key}_`].split(',').length)
        return acc * (lengthSum === 0 ? 1 : lengthSum)
      }, 1)
      this.recordCount = count
    },
    tkURLObjInit() {
      this.tkURLObj = { ...trackingURLObj_cpnts, ...trackingURLObj_params }
      this.recordTmp = {}
      this.recordCount = 0
    },
    cnccObjInit() {
      this.recordTmp = {}
      this.tkURLObj['cn-cs'] = ''
      this.tkURLObj['cn-cp'] = ''
      this.tkURLObj['cn-pn'] = ''
      this.tkURLObj['cn-at'] = ''
      this.tkURLObj['cc-at'] = ''
      this.tkURLObj['cc-cr'] = ''
      this.tkURLObj['cc-af'] = ''
      this.tkURLObj['cc-ag'] = ''
    },
    curStepTypeSet(val) {
      this.curStepType = val
    },
    curCpntTypeSet(val) {
      this.curCpntType = val
    },
    isVisibleSet(key, val) {
      this.isVisible[key] = val
    },
    recordTmpSet(key, val) {
      this.recordTmp[key] = val
    },
  },
  persist: true,
})
